var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcXls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M20,4c1.1,0,2,0.9,2,2l0,0v12c0,1.1-0.9,2-2,2l0,0H4c-1.1,0-2-0.9-2-2l0,0L2,6c0-1.1,0.9-2,2-2l0,0H20z  M18.3,9c-0.5,0-0.9,0.1-1.2,0.2c-0.4,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,1c0,0.4,0.1,0.8,0.4,1.1s0.7,0.6,1.3,0.8 c0.3,0.1,0.6,0.2,0.7,0.3s0.3,0.2,0.4,0.3c0.1,0.1,0.1,0.2,0.1,0.3c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.4,0.1-0.7,0.1 c-0.3,0-0.7,0-1-0.1c-0.4-0.1-0.7-0.2-1-0.4v1.4c0.3,0.1,0.6,0.2,1,0.3c0.4,0.1,0.8,0.1,1.2,0.1c0.8,0,1.5-0.2,1.9-0.5 c0.4-0.3,0.6-0.8,0.6-1.4c0-0.3-0.1-0.6-0.2-0.8s-0.3-0.4-0.5-0.6c-0.2-0.2-0.6-0.3-1-0.5c-0.5-0.2-0.8-0.3-1-0.4s-0.3-0.2-0.3-0.4 s0.1-0.3,0.3-0.4c0.2-0.1,0.4-0.1,0.7-0.1c0.5,0,1.1,0.1,1.6,0.4V9.4c-0.3-0.1-0.6-0.2-0.9-0.3C19,9,18.6,9,18.3,9z M5.1,9.1H3.2 l2.3,3.1l-2.3,3.2h1.8l1.4-1.9l1.4,1.9h1.8l-2.3-3.2l2.3-3.1H7.8L6.4,11L5.1,9.1z M12.3,9.1h-1.6v6.3h4.3v-1.3h-2.7V9.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXls);
export default __webpack_public_path__ + "static/media/ic_XLS.0a44ea86.svg";
export { ForwardRef as ReactComponent };